export default class Doctor {
  constructor({
    title,
    nom,
    prenom,
    profession,
    professionPlural,
    posSpeciality,
    telephone,
    conventionnement,
    carte_vitale: vitalCard,
    url,
    aos: listAo,
    ss_field_icon_type: icon,

  } = {}) {
    this.title = title || '';
    this.firstname = nom || '';
    this.lastname = prenom || '';
    this.profession = profession || '';
    this.professionPlural = professionPlural || '';
    this.posSpeciality = posSpeciality || '';
    this.phone = telephone || '';
    this.conventionnement = conventionnement || '';
    this.vitalCard = vitalCard || '';
    this.url = url || '';
    this.listAo = listAo || false;
    this.icon = icon || 'icon-autres-ps';
  }

  getTitle() {
    return this.title;
  }

  getLastname() {
    return this.nom;
  }

  getFirstname() {
    return this.prenom;
  }

  getProfession() {
    return this.profession;
  }

  getProfessionPlural() {
    return this.professionPlural;
  }

  getPosSpeciality() {
    return this.posSpeciality;
  }

  getPhone() {
    return this.phone;
  }

  getConventionnement() {
    return this.conventionnement; // TODO: Voir avec le developpeur back pour le renvoit de la phrase entiere, et non un chiffre/null.
  }

  getCarteVitale() {
    return this.vitalCard;
  }

  getUrl() {
    return this.url;
  }

  getListAo() {
    return this.listAo;
  }

  getPsIcon() {
    return this.icon;
  }
}
